import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(bubble);

import { css } from './css';
import { isString, isObject, isArray } from './is';
import { forOwn } from './object';
export function createElement(arg1, arg2, arg3) {
  var el;
  var elementArg = {};
  var parent = arg3; // 如果是<div></div>这种形式,直接制作成元素

  if (isString(arg1)) {
    if (arg1.charAt(0) === '<') {
      el = document.createElement('div');
      el.innerHTML = arg1;
      el = el.firstElementChild;
    } else {
      // 否则是div.class1.class2#id这种形式
      var classIdReg = /([.#][^.#]*)/g;
      var classId;
      el = document.createElement(arg1.split(/[#.]/)[0]); // eslint-disable-next-line no-cond-assign

      while (classId = classIdReg.exec(arg1)) {
        classId = classId[0];
        classId.charAt(0) === '#' ? el.id = classId.substring(1) : el.classList.add(classId.substring(1));
      }
    }
  } else {
    el = arg1;
  }

  if (isString(arg2)) {
    // 参数2是字符串,作为innerHTML
    el.innerHTML = arg2;
  } else if (isObject(arg2)) {
    // 是对象的话,每个字段处理
    elementArg = arg2;
  } else if (isArray(arg2)) {
    // 如果是数组,视为子元素
    elementArg.children = arg2;
  } else {
    // 否则视为父元素
    parent = arg2;
  }

  elementArg && forOwn(elementArg, function (value, key) {
    if (value !== undefined) {
      switch (key) {
        case 'deal':
          break;

        case 'classList':
          if (isString(value)) {
            el.classList.add(value);
          } else if (isArray(value)) {
            value.forEach(function (className) {
              el.classList.add(className);
            });
          }

          break;

        case 'children':
          if (isArray(value)) {
            value.forEach(function (node) {
              el.appendChild(node);
            });
          } else {
            el.appendChild(value);
          }

          break;

        case 'attr':
          forOwn(value, function (v, k) {
            el.setAttribute(k, v);
          });
          break;

        case 'style':
          css(el, value);
          break;

        default:
          if (key.substring(0, 5) === 'data-') {
            el.setAttribute(key, value);
          } else {
            el[key] = value;
          }

          break;
      }
    }
  });
  parent && parent.appendChild(el);
  elementArg && elementArg.deal && elementArg.deal(el);
  return el;
}
export function bindEvent(el, eventName, response) {
  var option = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    capture: true
  };
  el.addEventListener(eventName, response, option);
  return {
    remove: function remove() {
      el.removeEventListener(eventName, response, option);
    }
  };
}
export function setClass(el, className, flag) {
  var _el$classList, _el$classList2;

  var classList = [].concat(className);
  flag ? (_el$classList = el.classList).add.apply(_el$classList, _toConsumableArray(classList)) : (_el$classList2 = el.classList).remove.apply(_el$classList2, _toConsumableArray(classList));
}
/**
 *
 * 返回一个元素的祖先元素迭代器
 * @export
 * @param {Element} element 目标元素
 * @param {Element} [root=null] 冒泡终点
 * @returns {Generator<Element>} 祖先元素迭代器
 */

export function bubble(element) {
  var root,
      _ref,
      _ref$getParent,
      getParent,
      _args = arguments;

  return _regeneratorRuntime.wrap(function bubble$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          root = _args.length > 1 && _args[1] !== undefined ? _args[1] : null;
          _ref = _args.length > 2 && _args[2] !== undefined ? _args[2] : {}, _ref$getParent = _ref.getParent, getParent = _ref$getParent === void 0 ? function (el) {
            return el.parentElement;
          } : _ref$getParent;

        case 2:
          if (!(element !== root && element)) {
            _context.next = 8;
            break;
          }

          _context.next = 5;
          return element;

        case 5:
          element = getParent(element);
          _context.next = 2;
          break;

        case 8:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
/**
 * 移除元素
 */

export function removeElement(el) {
  if (!el) {
    return;
  }

  el.parentElement.removeChild(el);
}